import $ from "jquery";
import { trackStructEvent, trackSelfDescribingEvent } from "@snowplow/browser-tracker";
import { addTrans, addItem, trackTrans } from "@snowplow/browser-plugin-ecommerce";

const snowplowConfig = JSON.parse(document.querySelector("meta[property='snowplow']").getAttribute("content"));
const customEventsIdentifier = snowplowConfig.custom_events_identifier;
const eventsIdentifier = snowplowConfig.events_identifier;

window.track = function (category, action, label, item, transaction_id = null) {
  var sampleRate = 1;
  if (category === "Editor") {
    sampleRate = 1000;
  }
  if (sampleRate > 1 && Math.random() > 1 / sampleRate) {
    return;
  }

  if (typeof window.gtag !== "undefined") {
    window.gtag("event", action, {
      transaction_id: transaction_id,
      currency: "USD",
      event_category: category,
      event_label: label,
      items: [item],
    });
  }

  if (snowplowConfig.enabled) {
    trackStructEvent(
      {
        category: category,
        action: action,
        label: label,
      },
      [customEventsIdentifier, eventsIdentifier]
    );

    if (transaction_id != null) {
      addTrans(
        {
          orderId: transaction_id,
          currency: "USD",
          total: item.price,
        },
        [customEventsIdentifier]
      );

      const itemData = { orderId: transaction_id, ...item };
      // Change the name of the id property from id to sku to match the Snowplow schema
      itemData.sku = itemData.id;
      delete itemData.id;
      addItem(itemData, [customEventsIdentifier]);

      trackTrans([customEventsIdentifier]);
    }
  }
};

$(() => {
  $(".ga-tracked").on("click", function (event) {
    window.track($(this).data("ga-category"), $(this).data("ga-event"), $(this).data("ga-label"));
  });
});
